import TermsServicePage from './TermsServicePage';

export default TermsServicePage;
